import { request } from "../base";

export type FeedbackEntry = {
	id: number;
	userId: string | null;
	proId: string | null;
	category: string;
	message: string;
	pageUrl: string | null;
	userEmail: string | null;
	browser: string | null;
	screenResolution: string | null;
	location: string | null;
	status: string;
	createdAt: string;
};

export const adminFeedbackApi = {
	listFeedback(filters?: {
		page?: number;
		limit?: number;
		status?: string;
	}) {
		const params = new URLSearchParams();
		if (filters?.page) params.set("page", String(filters.page));
		if (filters?.limit) params.set("limit", String(filters.limit));
		if (filters?.status) params.set("status", filters.status);
		const qs = params.toString();
		return request<FeedbackEntry[]>(
			`/api/admin/feedback${qs ? `?${qs}` : ""}`,
		);
	},

	updateFeedbackStatus(id: number, status: string) {
		return request<FeedbackEntry>(`/api/admin/feedback/${id}`, {
			method: "PATCH",
			body: { status },
		});
	},
};
